import ky, { HTTPError, KyInstance, KyResponse } from "ky";

const errorInterceptor = async (error: HTTPError) => {
  const { response } = error;

  // Guard: Only process errors with valid response
  if (!response) {
    return error;
  }

  // Don't process server errors (500) and not found (404)
  if (response.status === 500 || response.status === 404) {
    return error;
  }

  // Clone response before reading to avoid consuming the stream
  try {
    const clonedResponse = response.clone() as KyResponse;
    const body: Record<string, string> = await clonedResponse.json();

    const key = Object.keys(body)[0];

    if (key) {
      error.name = key;
      error.message = body[key];
    }
  } catch (e) {
    // Failed to parse JSON or clone - return original error
    console.warn("Failed to parse error response:", e);
  }

  return error;
};

const createApiClient = (baseURL: string): KyInstance => {
  const kyClient = ky.create({
    prefixUrl: baseURL,
    timeout: 15000,
    hooks: { beforeError: [errorInterceptor] },
    retry: 0,
  });

  return kyClient;
};

export default createApiClient;
